module.exports = __webpack_public_path__ + "static/media/bewal1.bc845265.jpg";